const grayColor = '#C0C0C0';
const gridColor = '#e8e8e8';
const fontSize = 12;

export const defaultBarChartConfig = {
  scaleShowVerticalLines: false,
  maintainAspectRatio: false,
  responsive: true,

  tooltips: {
    callbacks: {
      label: function(tooltipItem, data) {
        return data.datasets[0].data[tooltipItem.index];
      }
    }
  },

  plugins: {
    datalabels: {
      color: 'white',
      // WARNING: meta.data._model is PRIVATE and thus can
      // change without notice, breaking code relying on it!
      display: function(context) {
        const chart = context.chart;
        const meta = chart.getDatasetMeta(context.datasetIndex);

        const model = meta.data[context.dataIndex]._model;
        const left = Math.max(model.base, chart.chartArea.left);
        const width = model.x - left;
        return width > 25;
      },
      formatter: Math.round
    }
  },

  scales: {
    yAxes: [
      {
        gridLines: { display: false },
        ticks: {
          fontColor: grayColor,
          fontSize
        }
      }
    ],
    xAxes: [
      {
        gridLines: {
          color: gridColor
        },
        ticks: {
          fontColor: grayColor,
          fontSize,
          beginAtZero: true,
          userCallback: function(label) {
            // when the floored value is the same as the value we have a whole number
            if (Math.floor(label) === label) {
              return label;
            }
          }
        }
      }
    ]
  }
};
